<template>
  <div class="caseSolution" :style="headStyle">
    <div class="mid-box">
      <div class="title">行业解决方案</div>
      <div class="content">
        <div class="content-left">
          <div class="left-item">
            <div
              class="item"
              v-for="(items, index) in tabList"
              :key="index"
              @click="clickTabs(items.key)"
              :class="{ tab_active: items.key === caseTabKey }">
              {{ items.tabName }}
            </div>
          </div>
        </div>
        <div class="content-right">
          <div class="right-head">
            <span class="title">
              制造业解决方案
              <!-- {{ tabObj[caseTabKey].title }} -->
            </span>
            <div class="subtitle">
              <!-- {{ tabObj[caseTabKey].content }} -->
              集成HR系统、财务系统、增值税发票综合服务平台，实现发票、财报等税基数据的自动采集。个人所得税、企业所得税（季度预缴、年度汇算清缴）等的自动计税和一键申报，电子档案、法规政策库、税务智能分析和集团管理视图。
            </div>
          </div>
          <div class="right-bottom">
            <a-button class="btn-details">了解案例详情</a-button>
            <a-button class="btn-trial">申请试用</a-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const tabList = [
  {
    key: '1',
    tabName: '制造业'
  },
  {
    key: '2',
    tabName: '消费零售'
  },
  {
    key: '3',
    tabName: '互联网平台'
  },
  {
    key: '4',
    tabName: '物流运输'
  },
  {
    key: '5',
    tabName: '能源综合'
  },
  {
    key: '6',
    tabName: '金融行业'
  },
  {
    key: '7',
    tabName: '地产行业'
  },
  {
    key: '8',
    tabName: '跨境贸易'
  },
  {
    key: '9',
    tabName: '软件行业'
  },
  {
    key: '10',
    tabName: '公共服务'
  }
]
const tabObj = {
  '1': {
    title: '制造业解决方案',
    content: '集成HR系统、财务系统、增值税发票综合服务平台，实现发票、财报等税基数据的自动采集。个人所得税、企业所得税（季度预缴、年度汇算清缴）等的自动计税和一键申报，电子档案、法规政策库、税务智能分析和集团管理视图。'
  }
}
export default {
  data () {
    return {
      headStyle: {
        backgroundImage: 'url(' + require('@/assets/images/home_case_bg_zh.png') + ')',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      },
      tabList,
      caseTabKey: '1',
      tabObj
    }
  },
  methods: {
    clickTabs (key) {
      this.caseTabKey = key
    }
  }
}
</script>

<style lang="less" scoped>
#hm-web {
.caseSolution {
  width: 100%;
  height: 684px;
  background-color: #515A63;
  display: flex;
  justify-content: center;
  .mid-box{
    width: 1200px;
    margin: 0 auto;
    padding-top: 66px;
    backdrop-filter: blur(4px);
  }
  .title {
    font-family: PingFangSC-Semibold;
    font-size: 36px;
    color: #FFFFFF;
    text-align: center;
    line-height: 36px;
    font-weight: 600;
  }
  .content {
    margin-top: 54px;
    width: 1200px;
    height: 524px;
    display: flex;
    .content-left {
      width: 260px;
      height: 100%;
      text-align: center;
      white-space: nowrap;
      overflow-x: hidden;
      overflow-y: scroll;
      background-image: linear-gradient(270deg, rgba(41,47,58,0.68));
      .left-item {
        padding: 24px 10px;
        color: #FFFFFF;
        .item {
          font-size: 18px;
          height: 50px;
          width: 100%;
          border-radius: 8px;
          margin-bottom: 8px;
          display: flex;
          align-items: center;
          padding-left: 30px;
          cursor: pointer;
        }
      }
      .item:hover,
      .tab_active {
        background-image: linear-gradient(104deg, #3E77FF 0%, #3BA7FC 100%, #68A4F2 100%);
        &.item {
          font-weight: 600;
        }
      }
    }
    .content-left {
      scrollbar-color: transparent;
      scrollbar-width: thin;
      &::-webkit-scrollbar {
        display: block;
        width: 5px;
        height: 5px;
      }
      &::-webkit-scrollbar-track{
        border-radius: 0px;
        background: transparent;
      }
      /*滑块*/
      &::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background-color: transparent;
      }
      // 滑块效果
      &::-webkit-scrollbar-thumb:hover{
        border-radius: 5px;
        background-color: transparent;
      }
    }
    .content-right {
      flex: 1;
      height: 100%;
      background-image: linear-gradient(270deg, rgba(41,47,58,0.41));
      padding-left: 75px;
      padding-right: 89px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .right-head {
        height: 347.5px;
        padding-top: 60px;
        text-align: left;
        color: #FFFFFF;
        .title {
          font-family: PingFangSC-Semibold;
          font-size: 20px;
          line-height: 26px;
          font-weight: 600;
        }
        .subtitle {
          margin-top: 27px;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          line-height: 26px;
          font-weight: 400;
        }
      }
      .right-bottom {
        flex: 1;
        width: 100%;
        border-top: 1px solid rgba(234,241,255,0.25);
        padding-top: 34px;
        text-align: left;
        .btn-details {
          width: 148px;
          height: 47px;
          font-size: 16px;
          color: #FFFFFF;
          text-align: center;
          font-weight: 600;
          margin-right: 20px;
          background-image: linear-gradient(111deg, #3E77FF 0%, #3BA7FC 100%, #68A4F2 100%);
          border: none;
        }
        .btn-trial {
          width: 118px;
          height: 47px;
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #FFFFFF;
          font-weight: 600;
          background-color: transparent;
          border: 1px solid #d9d9d9;
        }
      }
    }
  }
}
/deep/.ant-btn {
  border: none;
}
}
</style>
<style lang="less">

</style>



// WEBPACK FOOTER //
// src/views/home/components/caseSolution.vue